import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { IVenueState } from '@/store/types'
import store from '@/store'
import {
  UpdateMemberHomeShopRequest,
  VenueAPI,
  VenueEntity,
  ResponseStatus
} from '@/api/venue'

@Module({ dynamic: true, store: store, namespaced: true, name: 'venue' })
export default class VenueModule extends VuexModule implements IVenueState {
  applicationVenueId: string = ''
  applicationVenue: VenueEntity | null = null

  // Update member homeshop
  @Action({ rawError: true })
  async setMemberHomeShop(memberId: string) {
    if (!this.applicationVenueId) return
    try {
      const response = await VenueAPI.setMemberHomeShop(
        this.applicationVenueId,
        {
          memberId: memberId
        } as UpdateMemberHomeShopRequest
      )
      let payload = response.data.payload
      if (response.data.status === ResponseStatus.Ok && payload) {
        return payload
      }
    } catch (err) {
      throw err
    }
  }

  @Mutation
  SET_VENUE_ID(applicationVenueId: string) {
    this.applicationVenueId = applicationVenueId
  }

  // Application venue
  @Action({ rawError: true })
  setApplicationVenue(venue: VenueEntity) {
    this.context.commit('SET_APPLICATION_VENUE', venue)
  }

  @Mutation
  SET_APPLICATION_VENUE(venue: VenueEntity) {
    this.applicationVenue = venue
    this.applicationVenueId = venue.venueId
  }
}
